import script from "./CustomTableListActions.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTableListActions.vue?vue&type=script&setup=true&lang=js"

import "./CustomTableListActions.vue?vue&type=style&index=0&id=260296d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260296d6"]])

export default __exports__